<div class="dialog-overlay">
  <div class="dialog-box">
    <h1 mat-dialog-title>Register</h1>

    <div mat-dialog-content>
      <form
        [formGroup]="userForm"
        class="login-form"
      >
        <app-text-input
          label="Name"
          [control]="$any(userForm.get('name'))"
          placeholder="Enter your name"
        >
          <span error>Name is required</span>
        </app-text-input>

        <app-text-input
          label="Email"
          [control]="$any(userForm.get('email'))"
          placeholder="Enter your email"
        >
          <span error>Email is required and must be valid</span>
        </app-text-input>

        <app-mobile-number-input
          label="Mobile Number"
          [control]="$any(userForm.get('mobileNumber'))"
          placeholder="Enter your Mobile Number"
        >
          <span error>Mobile Number is required</span>
        </app-mobile-number-input>

        <app-text-input
          label="Company"
          [control]="$any(userForm.get('company'))"
          placeholder="Enter your Company"
        >
          <span error>Company is required</span>
        </app-text-input>

        <app-text-input
          label="Designation"
          [control]="$any(userForm.get('designation'))"
          placeholder="Enter your Designation"
        >
          <span error>Designation is required</span>
        </app-text-input>
      </form>
    </div>

    <div style="text-align: center">
      By registering on this site you agree to our

      <a href="https://zippmat.com/terms.html"> Terms and Conditions </a>
      and <a href="https://zippmat.com/privacy-policy.html">Privacy Policy</a>
    </div>

    <div
      style="place-content: center"
      mat-dialog-actions
    >
      <button
        mat-button
        class="close"
        (click)="onClose()"
      >
        Close
      </button>

      <button
        mat-button
        class="submit"
        (click)="onSubmit()"
        [disabled]="!userForm.valid"
      >
        Submit
      </button>
    </div>
  </div>
</div>
